import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { Venue } from '../domain/Venue'

@Component({
    selector: 'app-booking-policy-step',
    templateUrl: 'booking-policy-step.component.html',
})
export class BookingPolicyStepComponent implements OnChanges {

    @Input() venue!: Venue
    @Input() partySize!: number
    @Output() acceptedPolicy = new EventEmitter<void>()
    policyContent: string = ''

    ngOnChanges() {
        this.policyContent = ''
        if (this.shouldShowBasePolicy) {
            this.policyContent += this.venue.bookingPolicy + '<br>'
        }
        if (this.shouldShowLargePartyPolicy) {
            this.policyContent += this.venue.largePartyBookingPolicy + '<br>'
        }
    }

    get shouldShowBasePolicy(): boolean {
        if (!this.venue.bookingPolicy) {
            return false
        }
        return this.venue.bookingPolicy.length > 0
    }

    get shouldShowLargePartyPolicy(): boolean {
        if (!this.venue.largePartyBookingPolicy) {
            return false
        }
        if (this.venue.largePartyBookingPolicy.length <= 0) {
            return false
        }
        if (this.venue.largePartyBookingPolicyMinimumPartySize === null) {
            return true
        }
        if (this.partySize < this.venue.largePartyBookingPolicyMinimumPartySize) {
            return false
        }
        return true
    }
}
